import { ComponentType as t } from "../../registries/types/propTypes.js";
const d = (a) => {
  const e = Array.isArray(a == null ? void 0 : a.audio_player) ? a == null ? void 0 : a.audio_player[0] : a == null ? void 0 : a.audio_player;
  return {
    componentType: t.audio_player,
    audio_file: e.audio ?? {}
  };
};
export {
  d as default
};
//# sourceMappingURL=audioplayer-transformer.js.map
